<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem><b>1号AI > 智能体选题</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
	  		<span class="search_span_width" style="margin-right: 10px;">
	  				<span class="search_span_width_part1">ID：</span>
	  				<Input v-model="search.id"  style="width: 100px" />
        </span>
        <span class="search_span_width">
          <span class="search_span_width_part1">用户：</span>
          <Select
              v-model="search.user_id"
              filterable
              :remote-method="userList"
              :loading="loading3"  clearable style="width: 180px">
            <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.nickname}}</Option>
          </Select>
	      </span>


        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
      </Card>
      <Card id="tableContent" >
        <Table :columns="tableColumns" :data="data_list" height="600"></Table>
        <Page :total="total" :current="search.page" :page-size=search.pagesize :show-elevator="true" @on-change="getList"/>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      total:20,
      search:{
        page:1,
        pagesize:10
      },
      user_list:[],
      loading3: false,
      data_list:[],
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center',width: 100,"fixed": "left" },
        { title: '标题', key: 'title', align: 'center' ,"fixed": "left", width: 150},
        { title: '用户', key: 'nickname', align: 'center',"fixed": "left", width: 100 },
        { title: '封面', key: 'cover', width: 100, align: 'center',render:(h,params) =>{
            return h('img',{
              attrs : {src : params.row.cover},
              style : { width : '80px' }
            })
          }
        },

        { title: '角色ID', key: 'role_id', align: 'center', width: 100 },
        { title: '框架ID', key: 'ipframe_id', align: 'center' , width: 150},
        { title: '模版ID', key: 'template_id', align: 'center', width: 150 },
        { title: '是否星选', key: 'is_select', width: 100, align: 'center',render:(h,params) =>{
            if(params.row.is_select==1){
              return h('span',{},"是");
            }
            return h('span',{},"否");
          } },
        { title: '是否最新', key: 'is_new',width: 100, align: 'center',render:(h,params) =>{
            if(params.row.is_new==1){
              return h('span',{},"是");
            }
            return h('span',{},"否");
          } },
        { title: '关联视频ID', key: 'studio_id',width: 150, align: 'center' },
        { title: '使用人物ID', key: 'figure_id',width: 150, align: 'center' },
        { title: '声音ID', key: 'spk_id',width: 100, align: 'center' },
        { title: '推荐原因', key: 'reason',width: 300, align: 'center' },
        { title: '介绍', key: 'intro',width:800, align: 'center' },
        { title: '创建时间', key: 'created_at',width: 200, align: 'center' },
        { title: '更新时间', key: 'updated_at',width: 200, align: 'center' }
      ]
    }
  },
  mounted:function(){
    this.getList()
  },
  computed:{
  },
  methods:{
    getList(page){
      if(page){
        this.search.page = page
      }
      this.http.get('/admin/hotspot/getTopicList',{params:this.search}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.data_list = data.data.list;
          this.total = data.data.total
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    userList(query){
      if (query !== '' && query.length >=2) {
        this.loading3 = true;
        setTimeout(() => {
          this.loading3 = false;

          this.http1.get('/user/getUserSelectAll',{params:{nickname:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
  }

}
</script>
